/**
 * Tüm kullanıcıya görünen metinler.
 *
 * <p>Tek dosyada toplanmasının sebebi i18n değil tutarlılık: aynı kavram
 * her ekranda aynı kelimeyle anılsın ("proje sahibi" bir yerde "yönetici"
 * olmasın).
 */
export const tr = {
  app: {
    name: 'Arsivora',
    tagline: 'Proje bazlı not ve doküman yönetimi',
  },
  common: {
    save: 'Kaydet',
    cancel: 'Vazgeç',
    delete: 'Sil',
    edit: 'Düzenle',
    create: 'Oluştur',
    close: 'Kapat',
    search: 'Ara',
    loading: 'Yükleniyor…',
    empty: 'Burada henüz bir şey yok.',
    error: 'Bir hata oluştu.',
    retry: 'Tekrar dene',
    confirm: 'Onayla',
    yes: 'Evet',
    no: 'Hayır',
    back: 'Geri',
    download: 'İndir',
    upload: 'Yükle',
    rename: 'Yeniden adlandır',
    restore: 'Geri yükle',
    versions: 'Sürümler',
    tags: 'Etiketler',
    all: 'Tümü',
    required: 'Bu alan zorunlu.',
  },
  auth: {
    login: 'Giriş yap',
    logout: 'Çıkış yap',
    logoutAll: 'Tüm cihazlardan çık',
    username: 'Kullanıcı adı',
    password: 'Parola',
    currentPassword: 'Mevcut parola',
    newPassword: 'Yeni parola',
    newPasswordAgain: 'Yeni parola (tekrar)',
    changePassword: 'Parola değiştir',
    mustChangeTitle: 'Parolanızı değiştirin',
    mustChangeHint:
      'Hesabınız yönetici tarafından oluşturuldu. Devam etmeden önce kendinize ait bir parola belirlemeniz gerekiyor.',
    passwordMismatch: 'Parolalar eşleşmiyor.',
    passwordTooShort: 'Parola en az 10 karakter olmalı.',
    signingIn: 'Giriş yapılıyor…',
    forgotPassword: 'Parolamı unuttum',
    backToLogin: 'Giriş ekranına dön',
  },
  nav: {
    home: 'Ana sayfa',
    projects: 'Projeler',
    overview: 'Proje durumları',
    allTasks: 'Tüm görevler',
    offers: 'Teklifler',
    search: 'Arama',
    admin: 'Yönetim',
    users: 'Kullanıcılar',
    audit: 'Denetim kaydı',
    teams: 'Ekipler',
    roles: 'Roller',
    allProjects: 'Proje erişimleri',
    mail: 'E-posta',
    profile: 'Profilim',
  },
  project: {
    title: 'Projeler',
    newProject: 'Yeni proje',
    name: 'Proje adı',
    description: 'Açıklama',
    visibility: 'Görünürlük',
    private: 'Yalnızca ben',
    shared: 'Paylaşılan',
    privateHint: 'Bu projeyi yalnızca siz görebilirsiniz.',
    sharedHint: 'Seçtiğiniz kişiler projeyi görebilir.',
    owner: 'Sahibi',
    members: 'Üyeler',
    memberCount: 'üye',
    notes: 'Notlar',
    files: 'Dosyalar',
    activity: 'Hareketler',
    tests: 'Testler',
    vault: 'Kasa',
    deploy: 'Deploy',
    offers: 'Teklifler',
    tasks: 'Görevler',
    trash: 'Çöp kutusu',
    settings: 'Ayarlar',
    empty: 'Henüz bir projeniz yok.',
    emptyHint: 'İlk projenizi oluşturarak notlarınızı ve dosyalarınızı toplamaya başlayın.',
    deleteConfirm: 'Proje çöp kutusuna taşınacak. Devam edilsin mi?',
    leaveConfirm: 'Bu projeden ayrılmak istediğinize emin misiniz?',
    transferOwnership: 'Sahipliği devret',
  },
  member: {
    add: 'Üye ekle',
    role: 'Rol',
    owner: 'Sahip',
    editor: 'Düzenleyebilir',
    viewer: 'Görüntüleyebilir',
    ownerHint: 'Her şeyi yapabilir, üyeleri yönetir.',
    editorHint: 'Not ve dosya oluşturabilir, düzenleyebilir, silebilir.',
    viewerHint: 'Yalnızca görüntüler ve indirir.',
    tester: 'Test eden',
    testerHint: 'Yalnızca Testler sekmesini görür ve test sonucu girer.',
    removeConfirm: 'Bu üyenin projeye erişimi kaldırılacak.',
    leave: 'Projeden ayrıl',
    searchUser: 'Kullanıcı ara…',
  },
  note: {
    title: 'Notlar',
    newNote: 'Yeni not',
    untitled: 'Başlıksız not',
    empty: 'Bu projede henüz not yok.',
    emptyHint: 'Toplantı notları, fikirler, kontrol listeleri — hepsi burada.',
    placeholder: 'Yazmaya başlayın…',
    saving: 'Kaydediliyor…',
    saved: 'Tüm değişiklikler kaydedildi',
    saveFailed: 'Kaydedilemedi',
    unsavedWarning: 'Kaydedilmemiş değişiklikleriniz var.',
    versionHistory: 'Sürüm geçmişi',
    createVersion: 'Sürüm kaydet',
    restoreVersion: 'Bu sürüme dön',
    restoreConfirm:
      'Not bu sürüme geri yüklenecek. Şu anki hali de bir sürüm olarak saklanacağı için bu işlem geri alınabilir.',
    deleteConfirm: 'Not çöp kutusuna taşınacak.',
    pin: 'Sabitle',
    unpin: 'Sabitlemeyi kaldır',
    conflict: 'Bu not başka bir yerde değiştirildi. Sayfayı yenileyin.',
  },
  file: {
    title: 'Dosyalar',
    upload: 'Dosya yükle',
    uploadFolder: 'Klasör yükle',
    dropHere: 'Dosya ya da klasörleri buraya sürükleyin',
    dropHint: 'veya seçmek için tıklayın · en fazla 100 MB',
    empty: 'Bu projede henüz dosya yok.',
    emptyHint: 'Word, Excel, PDF ve diğer dosyalarınızı buraya yükleyin.',
    name: 'Ad',
    size: 'Boyut',
    updated: 'Güncellenme',
    updatedBy: 'Güncelleyen',
    openInEditor: 'Düzenle',
    view: 'Görüntüle',
    newVersion: 'Yeni sürüm yükle',
    versionCount: 'sürüm',
    deleteConfirm: 'Dosya çöp kutusuna taşınacak.',
    notEditable: 'Bu dosya türü uygulama içinde düzenlenemez; indirip açabilirsiniz.',
    uploading: 'Yükleniyor',
    uploadFailed: 'Yüklenemedi',
    kind: {
      WORD: 'Word', EXCEL: 'Excel', PRESENTATION: 'Sunum',
      PDF: 'PDF', IMAGE: 'Görsel', TEXT: 'Metin', OTHER: 'Diğer',
    },
  },
  admin: {
    users: 'Kullanıcılar',
    newUser: 'Yeni kullanıcı',
    editUser: 'Düzenle',
    displayName: 'Ad Soyad',
    email: 'E-posta',
    status: 'Durum',
    active: 'Etkin',
    disabled: 'Devre dışı',
    roles: 'Roller',
    lastLogin: 'Son giriş',
    never: 'Hiç',
    enable: 'Etkinleştir',
    disable: 'Devre dışı bırak',
    resetPassword: 'Parola sıfırla',
    forceLogout: 'Oturumları sonlandır',
    disableConfirm:
      'Hesap devre dışı bırakılacak ve kullanıcının açık oturumları anında sonlandırılacak.',
    sessions: 'Açık oturumlar',
    mobileAccessOff: 'Mobil erişimi kapat',
    mobileAccessOn: 'Mobil erişimi aç',
    mobileAccessOffConfirm:
      'Kullanıcı mobil uygulamaya giriş yapamayacak ve açık mobil oturumları anında sonlandırılacak. Web erişimi etkilenmez.',
    mobileAccessOffPill: 'mobil kapalı',
    sendPasswordLink: 'Parola bağlantısı gönder',
    invitePendingPill: 'davet bekliyor',
    auditLog: 'Denetim kaydı',
    statistics: 'Özet',
  },
  team: {
    title: 'Ekipler',
    newTeam: 'Yeni ekip',
    name: 'Ekip adı',
    description: 'Açıklama',
    members: 'Üyeler',
    projects: 'Projeler',
    addMember: 'Üye ekle',
    assign: 'Ekip ekle',
    empty: 'Henüz ekip yok.',
    emptyHint: 'Ekip oluşturup kişileri ekleyin; ekibi bir projeye atadığınızda üyelerinin hepsi erişim kazanır.',
    deleteConfirm:
      'Ekip silinecek. Ekip üzerinden projelere erişen kişiler, doğrudan üye değillerse erişimlerini kaybedecek.',
    removeFromProjectConfirm:
      'Ekip projeden kaldırılacak. Üyeleri, doğrudan üye değillerse projeye erişimlerini kaybedecek.',
    projectHint:
      'Ekibe sonradan katılan kişi projeye hemen erişir, ekipten çıkan hemen kaybeder. Ekip üyelerini yöneticiler düzenler.',
  },
  vault: {
    title: 'Kasa',
    newEntry: 'Yeni kayıt',
    editEntry: 'Kaydı düzenle',
    entryTitle: 'Başlık',
    kind: 'Tür',
    kinds: {
      ACCOUNT: 'Hesap', DOMAIN: 'Alan adı', PASSPORT: 'Pasaport', OTHER: 'Diğer',
    },
    fields: 'Alanlar',
    fieldLabel: 'Alan adı',
    fieldValue: 'Değer',
    addField: 'Alan ekle',
    secret: 'Gizli',
    show: 'Göster',
    hide: 'Gizle',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    generate: 'Güçlü parola üret',
    description: 'Açıklama',
    searchPlaceholder: 'Başlıkta ara…',
    empty: 'Kasada henüz kayıt yok.',
    emptyHint:
      'Kullanıcı adı/parola, alan adı ve pasaport gibi bilgileri başlık vererek saklayın. İçerik şifreli tutulur.',
    noMatch: 'Eşleşen kayıt yok',
    deleteConfirm: 'Kayıt kalıcı olarak silinecek; çöp kutusuna gitmez ve geri alınamaz.',
    viewerHint: 'Yalnızca görüntüleyebilirsiniz; kayıt ekleyip düzenlemek için "Düzenleyebilir" rolü gerekir.',
    auditHint: 'Kayıtların açılması proje hareketlerine yazılır.',
    conflict: 'Bu kayıt başka biri tarafından değiştirildi. Kapatıp yeniden açın.',
    noFields: 'Bu kayıtta alan yok.',
  },
  deploy: {
    title: 'Deploy',
    views: { ortamlar: 'Ortamlar', gecmis: 'Geçmiş', sunucular: 'Sunucular', kimlikler: 'Kimlik bilgileri' },
    run: 'Çalıştır',
    cancelRun: 'Durdur',
    rerun: 'Yeniden çalıştır',
    newEnvironment: 'Ortam ekle',
    newJob: 'İş ekle',
    newServer: 'Sunucu ekle',
    newCredential: 'Kimlik bilgisi ekle',
    envKinds: { DEV: 'Geliştirme', TEST: 'Test', STAGING: 'Ön canlı', PROD: 'Canlı', OTHER: 'Diğer' },
    credentialKinds: {
      SSH_KEY: 'SSH özel anahtarı (.pem / deploy key)', SSH_PASSWORD: 'SSH parolası', AWS_KEYS: 'AWS erişim anahtarı',
      GIT_TOKEN: 'Git erişim jetonu (HTTPS)',
    },
    stepTypes: { COMMAND: 'Komut', PROMPT: 'Soru sor', UPLOAD: 'Dosya yükle', HEALTH: 'Sağlık kontrolü', GIT: 'Git: kodu çek' },
    runWhen: { SUCCESS: 'Önceki adımlar başarılıysa', FAILURE: 'Yalnızca hata olduysa', ALWAYS: 'Her durumda' },
    promptTypes: { CONFIRM: 'Evet / Hayır', CHOICE: 'Seçenek listesi', TEXT: 'Metin', SECRET: 'Gizli metin (parola)' },
    ops: {
      EQUALS: 'eşittir', NOT_EQUALS: 'eşit değildir', CONTAINS: 'içerir', NOT_CONTAINS: 'içermez',
      MATCHES: 'düzenli ifadeyle eşleşir', EMPTY: 'boştur', NOT_EMPTY: 'doludur',
    },
    runStatus: {
      QUEUED: 'Sırada', RUNNING: 'Çalışıyor', WAITING_INPUT: 'Cevap bekliyor', SUCCESS: 'Başarılı',
      FAILED: 'Başarısız', CANCELLED: 'Durduruldu',
    },
    stepStatus: {
      PENDING: 'Bekliyor', RUNNING: 'Çalışıyor', WAITING: 'Cevap bekliyor', SUCCESS: 'Tamam', FAILED: 'Hata',
      SKIPPED: 'Atlandı', CANCELLED: 'İptal',
    },
    secretKept: 'Kayıtlı — değiştirmek için yenisini yazın',
    conflict: 'Bu kayıt başka biri tarafından değiştirildi. Kapatıp yeniden açın.',
    viewerHint: 'Yalnızca izleyebilirsiniz; deploy başlatmak için rolünüzde "Deploy çalıştırır" izni gerekir.',
    editorHint: 'Sunucu, kimlik bilgisi ve komutları düzenlemek için rolünüzde "Deploy kurulumunu yönetir" izni gerekir.',
  },
  task: {
    title: 'Görevler',
    newTask: 'Yeni görev',
    editTask: 'Görevi düzenle',
    taskTitle: 'Başlık',
    description: 'Açıklama',
    column: 'Durum',
    priority: 'Öncelik',
    priorities: { LOW: 'Düşük', MEDIUM: 'Orta', HIGH: 'Yüksek', URGENT: 'Acil' },
    assignee: 'Atanan kişi',
    assignees: 'Atanan kişiler',
    teams: 'Ekipler',
    unassigned: 'Atanmamış',
    type: 'Tür',
    types: { TASK: 'Görev', BUG: 'Hata', STORY: 'Hikâye', IMPROVEMENT: 'İyileştirme', EPIC: 'Epik' },
    labels: 'Etiketler',
    storyPoints: 'Puan',
    startDate: 'Başlangıç',
    checklist: 'Alt görevler',
    addChecklist: 'Alt görev ekle',
    attachments: 'Ekler',
    addAttachment: 'Dosya ekle',
    comments: 'Yorumlar',
    history: 'Geçmiş',
    details: 'Ayrıntılar',
    board: 'Pano',
    list: 'Liste',
    copyLink: 'Bağlantıyı kopyala',
    linkCopied: 'Görev bağlantısı kopyalandı.',
    quickAdd: 'Ne yapılması gerekiyor?',
    onlyMine: 'Yalnızca benimkiler',
    commentPlaceholder: 'Yorum ekleyin… (görsel yapıştırabilir ya da dosya sürükleyebilirsiniz)',
    noComments: 'Henüz yorum yok. İlk yorumu siz yazın.',
    noHistory: 'Henüz geçmiş kaydı yok.',
    noDescription: 'Açıklama eklemek için tıklayın…',
    edited: 'düzenlendi',
    dueDate: 'Bitiş tarihi',
    overdue: 'Gecikti',
    searchPlaceholder: 'Görevlerde ara…',
    everyone: 'Herkes',
    mine: 'Bana atananlar',
    addTask: 'Görev ekle',
    addColumn: 'Sütun ekle',
    newColumn: 'Yeni sütun',
    editColumn: 'Sütunu düzenle',
    columnName: 'Sütun adı',
    color: 'Renk',
    doneColumn: 'Bu sütundaki görevler tamamlanmış sayılır',
    moveLeft: 'Sola taşı',
    moveRight: 'Sağa taşı',
    deleteColumnConfirm:
      'Sütun silinecek. İçindeki görevler silinmez, komşu sütunun sonuna taşınır.',
    deleteConfirm: 'Görev kalıcı olarak silinecek; çöp kutusuna gitmez.',
    emptyColumn: 'Görev yok',
    dropHere: 'Buraya bırakın',
    viewerHint: 'Yalnızca görüntüleyebilirsiniz; görev eklemek ve taşımak için "Düzenleyebilir" rolü gerekir.',
    dragHint: 'Kartları sürükleyerek durumlarını değiştirebilirsiniz.',
    conflict: 'Bu görev başka biri tarafından değiştirildi. Kapatıp yeniden açın.',
    createdBy: 'Oluşturan',
    noMatch: 'Filtreye uyan görev yok.',
  },
  allTasks: {
    title: 'Tüm görevler',
    subtitle: 'Erişiminiz olan projelerdeki bütün görevler',
    project: 'Proje',
    allProjects: 'Proje erişimleri',
    person: 'Kişi',
    everyone: 'Herkes',
    status: 'Durum',
    open: 'Açık',
    done: 'Tamamlanan',
    all: 'Tümü',
    priority: 'Öncelik',
    anyPriority: 'Tüm öncelikler',
    overdueOnly: 'Yalnızca gecikenler',
    sort: 'Sıralama',
    sortDue: 'Bitiş tarihi',
    sortPriority: 'Öncelik',
    sortUpdated: 'Son güncellenen',
    group: 'Gruplama',
    groupNone: 'Yok',
    groupProject: 'Proje',
    groupPerson: 'Kişi',
    clear: 'Filtreleri temizle',
    colTask: 'Görev',
    colStatus: 'Durum',
    colAssignee: 'Atanan',
    colDue: 'Bitiş',
    colUpdated: 'Güncellendi',
    empty: 'Henüz hiç görev yok.',
    emptyHint: 'Bir projenin "Görevler" sekmesinden görev oluşturabilirsiniz.',
    noMatch: 'Filtrelere uyan görev yok.',
    truncated: 'Liste çok uzun olduğu için en eski tamamlanmış görevler gösterilmiyor.',
    myOpen: 'Bana atanan açık',
    overdue: 'Geciken',
    openCount: 'Açık görev',
  },
  stage: {
    title: 'Proje durumları',
    subtitle: 'Erişiminiz olan tüm projeler ve bulundukları aşama',
    stage: 'Proje durumu',
    none: 'Durum atanmamış',
    setStage: 'Durumu değiştir',
    note: 'Durum notu',
    notePlaceholder: 'Örn. müşteri onayı bekleniyor, 12 Ekim teslim',
    editNote: 'Durum notunu düzenle',
    manage: 'Durumları yönet',
    manageHint:
      'Durumlar tüm projeler için ortaktır. Silinen bir durumdaki projeler "Durum atanmamış" olur.',
    newStage: 'Durum ekle',
    stageName: 'Durum adı',
    list: 'Liste',
    board: 'Pano',
    searchPlaceholder: 'Projelerde ara…',
    tasks: 'görev',
    done: 'tamamlandı',
    myOpen: 'bana açık',
    empty: 'Henüz erişiminiz olan bir proje yok.',
    noMatch: 'Filtreye uyan proje yok.',
    deleteConfirm: 'Durum silinecek. Bu durumdaki projeler "Durum atanmamış" olarak kalacak.',
    boardHint: 'Projeleri sürükleyerek durumlarını değiştirebilirsiniz (düzenleme yetkiniz olan projelerde).',
  },
  search: {
    title: 'Arama',
    placeholder: 'Notlarda ve dosyalarda ara…',
    noResults: 'Sonuç bulunamadı.',
    noResultsHint: 'Farklı bir kelime deneyin. Arama büyük/küçük harf ve Türkçe karakter duyarsızdır.',
    resultCount: 'sonuç',
    inProject: 'Proje',
  },
} as const
